<div class="content-heading">
    <div>
        {{pageContent.title}}
        <small>{{pageContent.searchHeader}}</small>
    </div>
</div>
<div class="card card-default">
    <div class="card-body" [innerHtml]="pageContent.content">
    </div>
</div>
